import { Message } from 'lib-shared-legacy-types';

import { SurveyOfferState } from './types';

const messagesContainType = (messages: Message[], messageType: string) =>
  messages.some(({ type }) => type === messageType);

/**
 * Returns the state of the survey in case it is already triggered. Returns
 * undefined if the survey is not triggered yet, which means the survey can
 * still be modified by the agent if they have the necessary permissions.
 */
export function inferSurveyOfferStateFromConversationMessages(
  messages: Message[],
): SurveyOfferState | undefined {
  if (messagesContainType(messages, 'conversation:rated')) {
    return 'Answered';
  }

  if (messagesContainType(messages, 'conversation:rating_offered')) {
    return 'Offered';
  }

  if (messagesContainType(messages, 'conversation:rating_cancelled')) {
    return 'Cancelled';
  }

  return undefined;
}

type GetTooltipContentArgs = {
  isUserExcluded: boolean;
  isCancellable: boolean;
  hasNoLanguage: boolean;
  canChangeLanguage: boolean;
};
export function getTooltipContent({
  isUserExcluded,
  isCancellable,
  hasNoLanguage,
  canChangeLanguage,
}: GetTooltipContentArgs): string {
  if (isUserExcluded) {
    return 'This user is excluded from customer satisfaction';
  }

  if (!isCancellable) {
    return 'Survey can no longer be modified';
  }

  if (hasNoLanguage && canChangeLanguage) {
    return 'No matching language available - survey will not be offered. Select a language to enable customer satisfaction';
  }

  if (hasNoLanguage && !canChangeLanguage) {
    return 'No matching language available - survey will not be offered';
  }

  return 'Customer satisfaction';
}
